import { Circle } from "@chakra-ui/react";

export const FeaturedIcon: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <Circle size="56px" bg="gray.100" borderColor="gray.50" borderWidth="10px">
    {children}
  </Circle>
);
